<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش جلسات آنلاین حصوصی</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-select color="black" v-model="order" label="نوع ترتیب جلسات آنلاین را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getPrivateOnlineSessions()"></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/classes/online/create/')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت جلسه آنلاین جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="onlineSessions.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon color="success"
                        @click="$router.push('/classes/sessions/meeting/'+item.online_class_id+'/'+item.id+'/'+$store.state.user.id)">
                  mdi-login
                </v-icon>
                <v-icon class="mx-1" color="purple"
                        @click="$router.push('/classes/online/edit/'+item.id)">mdi-pen
                </v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.day`]="{ item }">
                <span v-if="item.day === 1">شنبه</span>
                <span v-else-if="item.day === 2">یکشنبه</span>
                <span v-else-if="item.day === 3">دوشنبه</span>
                <span v-else-if="item.day === 4">سه شنبه</span>
                <span v-else-if="item.day === 5">چهارشنبه</span>
                <span v-else-if="item.day === 6">پنجشنبه</span>
                <span v-else-if="item.day === 7">جمعه</span>
              </template>
              <template
                  v-slot:[`item.select`]="{ item }">
                <v-checkbox color="black" v-model="selectedSessionIds[item.id]">
                </v-checkbox>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-btn @click="destroyMulti" color="error" style="letter-spacing: normal!important">
              پاک کردن گروهی
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="onlineSessions.current_page"
                :length="onlineSessions.last_page"
                circle
                @input="getPrivateOnlineSessions"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OnlineSessionIndex",
  data() {
    return {
      classId: null,
      expanded: [],
      singleExpand: false,
      loading: true,
      selectedSessionIds: [],
      orderItems: [
        {name: 'بر اساس تیتر', value: 'title'},
        {name: 'بر اساس تاریخ شروع', value: 'starts_at'},
      ],
      order: 'starts_at',
      onlineSessions: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'عنوان', value: 'title', align: 'center'},
        {text: 'روز', value: 'day', align: 'center'},
        {text: 'تاریخ شروع', value: 'starts_at_fa', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center'},
        {text: 'انتخاب', value: 'select', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getPrivateOnlineSessions()
  },
  methods: {
    getPrivateOnlineSessions() {
      let url = '/session/crud/private/index/' + '?page=' + this.onlineSessions.current_page ?? 1
      url = url + '&order=' + this.order
      window.axios.get(url).then((res) => {
        this.onlineSessions = res.data.data
        this.onlineSessions.data.forEach((session) => {
          this.$set(this.selectedSessionIds, session.id, true)
        })
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(onlineSessionId) {
      window.axios.delete('session/crud/private/delete/' + onlineSessionId).then(() => {
        this.getPrivateOnlineSessions()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroyMulti() {
      window.axios.post('session/crud/private/multiple/delete', {
        ids: this.selectedSessionIds
      }).then(() => {
        this.getPrivateOnlineSessions()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style scoped>

</style>